import { render, staticRenderFns } from "./PaginationSizeSelect.vue?vue&type=template&id=272a78aa&scoped=true"
import script from "./PaginationSizeSelect.vue?vue&type=script&lang=js"
export * from "./PaginationSizeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272a78aa",
  null
  
)

export default component.exports